<template>
  <div>
    <h1>个人信息</h1>
    <p class="subheader">通过编辑下面的详细信息，使您的帐户保持最新。</p>
    <form>
      <div class="form-row">
        <div class="row-left">
          <div class="label">名称<span style="margin-left:.25em">*</span></div>
          <div>{{ userInfo.username }}</div>
        </div>
        <div class="edit" @click="toEditUserInfo">编辑</div>
      </div>
      <div class="form-row">
        <div class="row-left">
          <div class="label">称谓<span style="margin-left:.25em">*</span></div>
          <div>{{ ['-', '先生', '女士'][userInfo.gender] || '-' }}</div>
        </div>
      </div>
      <div class="form-row">
        <div class="row-left">
          <div class="label">生日<span style="margin-left:.25em">*</span></div>
          <div class="birthday-text">{{ userInfo.birthday || '-' }}</div>
          <div class="birthday-hits">(生日仅可修改一次)</div>
        </div>
      </div>
      <div class="form-row form-row-line">
        <div class="row-left">
          <div class="label">手机<span style="margin-left:.25em">*</span></div>
          <div>{{ userInfo.mobile }}</div>
        </div>
      </div>
      <!-- <div class="form-row form-row-line">
        <div class="row-left">
          <div class="label">邮箱</div>
          <div>{{userInfo.email}}</div>
        </div>
      </div> -->
      <div class="form-row form-row-line">
        <div class="row-left">
          <div class="label">密码<span style="margin-left:.25em">*</span></div>
          <div>********</div>
        </div>
        <div class="edit" @click="showChangePwdDialog = true">修改密码</div>
      </div>
      <div></div>
    </form>
    <!-- detail弹框 -->
    <el-dialog title="编辑个人信息" :visible.sync="dialogFormVisible" center>
      <el-form :model="form" :rules="rules" ref="ruleForm" :label-position="labelPosition">
        <el-form-item prop="username" label="姓名" :label-width="formLabelWidth">
          <el-input v-model.trim="form.username" autocomplete="off" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item prop="gender" label="称谓" :label-width="formLabelWidth">
          <el-select v-model="form.gender" placeholder="请选择称谓">
            <el-option label="先生" :value="1"></el-option>
            <el-option label="女士" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机" :label-width="formLabelWidth">
          <el-input v-model.trim="form.mobile" disabled="" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="birthday" label="生日" :label-width="formLabelWidth">
          <el-date-picker v-model="form.birthday" :disabled="form.birthday_lock == 1"
            :picker-options="birthPickerOptions" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item prop="email" label="邮箱" :label-width="formLabelWidth">
          <el-input v-model.trim="form.email" autocomplete="off" maxlength="50"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="showChangePwdDialog" center>
      <el-form :model="pwdForm" :rules="pwdFormRules" ref="pwdForm" :label-position="labelPosition">
        <el-form-item prop="oldPassword" label="当前密码" :label-width="formLabelWidth">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password autocomplete="off" minlength="8"
            maxlength="16"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword1" label="新密码" :label-width="formLabelWidth">
          <el-input v-model="pwdForm.newPassword1" type="password" show-password autocomplete="off" minlength="8"
            maxlength="16"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword2" label="再次确认" :label-width="formLabelWidth">
          <el-input v-model="pwdForm.newPassword2" type="password" show-password autocomplete="off" minlength="8"
            maxlength="16"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatePwd">确 定</el-button>
        <el-button @click="showChangePwdDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <WXUserCenter :show="wxDialogShow" :data="sendCouponDialogData" @updateShow="updateShow" />
  </div>
</template>

<script>
import api from '@/utils/api';
import types from '@/store/types';
import utils from "@/utils";
import WXUserCenter from "@/components/WXUserCenter.vue";
import { captureManualError } from '@/sentry/index'

export default {
  components: { WXUserCenter },
  data() {
    return {
      userInfo: {},
      wxDialogShow: false, // 个人中心微信弹框
      dialogFormVisible: false,
      form: {
        username: "",
        gender: "",
        mobile: "",
        birthday: "",
        birthday_lock: 1,
        email: ""
      },
      rules: {
        username: [{
          required: true,
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入姓名"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        gender: [{ required: true, message: "请选择称谓", trigger: "change" }],
        birthday: [{ required: true, message: "请输入生日", trigger: "change" }],
        email: [{
          validator(rule, value, callback) {
            // eslint-disable-next-line no-useless-escape
            if (value && !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(value)) {
              callback(new Error('请输入正确的邮箱地址'));
            } else {
              callback()
            }
          }, trigger: 'blur'
        }]
      },
      birthPickerOptions: {
        disabledDate(time) {
          // 生日字段输入做限制:最低年龄为14周岁
          const earliestAllowedDate = new Date();
          earliestAllowedDate.setFullYear(earliestAllowedDate.getFullYear() - 14);
          return time.getTime() > earliestAllowedDate.getTime();
        }
      },
      formLabelWidth: "85px",
      labelPosition: 'right',
      // 修改密码
      showChangePwdDialog: false,
      pwdForm: {
        oldPassword: "",
        newPassword1: "",
        newPassword2: ""
      },
      pwdFormRules: {
        oldPassword: [{ required: true, message: "请输入当前密码", trigger: "blur" }],
        newPassword1: [
          {
            required: true, validator: (fieldRule, value, callback) => {
              if (!value) {
                callback(new Error("请输入新密码"));
              } else if (value == this.pwdForm.oldPassword) {
                callback(new Error("新密码不能与当前密码一致"));
              } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/.test(value)) {
                callback(new Error("密码长度为8~16个字符且包含大小写字母、数字各一个"));
              } else {
                callback();
              }
            }, trigger: "blur"
          },
        ],
        newPassword2: [
          {
            required: true, validator: (fieldRule, value, callback) => {
              if (!value) {
                callback(new Error("请再次输入新密码"));
              } else if (value != this.pwdForm.newPassword1) {
                callback(new Error("两次输入的新密码不一致"));
              } else {
                callback();
              }
            }, trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.GET_PROFILE]().then(res => {
        if (res?.data) {
          this.userInfo = res.data;
          let userForm = Object.assign({}, this.userInfo);
          userForm.gender = String(userForm.gender);
          this.form = userForm;
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
        captureManualError(err)
      });
    },
    toEditUserInfo() {
      this.wxDialogShow = true
      // this.form = { ...this.userInfo };
      // this.dialogFormVisible = true;
    },
    updateShow(value) {
      this.wxDialogShow = value
    },
    saveInfo() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let newArgs = Object.assign({}, this.form);
          delete newArgs.mobile;
          api[types.UPDATE_PROFILE](newArgs).then(res => {
            if (res?.code == 1) {
              Object.assign(this.userInfo, this.form, { birthday_lock: 1 });
              this.$store.commit(types.GET_PROFILE, this.userInfo);
              this.$message({
                message: "更新成功",
                type: "success"
              });
              this.closeInfoDialog();
            } else {
              console.warn(res);
              this.$message({
                message: res.data.message,
                type: "warning"
              });
            }
          }).catch(err => {
            this.dialogFormVisible = false;
            console.warn(err);
            captureManualError(err)
          });
        }
      });
    },
    updatePwd() {
      this.$refs['pwdForm'].validate(valid => {
        if (valid) {
          let newArgs = {
            oldPwd: this.pwdForm.oldPassword,
            newPwd: this.pwdForm.newPassword1
          };
          api[types.CHANGE_PASSWORD](newArgs).then(res => {
            if (res?.code == 1) {
              this.$message({
                message: "密码更新成功",
                type: "success"
              });
              this.closePwdDialog();
            } else {
              console.warn(res);
            }
          }).catch(err => {
            console.warn(err);
            captureManualError(err)
          });
        }
      })
    },
    closeInfoDialog() {
      this.dialogFormVisible = false;
      this.form = { username: "", gender: "", mobile: "", birthday: "", email: "" };
    },
    closePwdDialog() {
      this.showChangePwdDialog = false;
      this.pwdForm = { oldPassword: '', newPassword1: '', newPassword2: '' };
    }
  },
  computed: {
    sendCouponDialogData() {
      const isBr = utils.isMobile() && utils.isWXBrowser() ? '<br>' : ''
      const describe = `请前往Onitsuka Tiger鬼塚虎官方线上店${isBr}完善个人信息`;
      return {
        title: '个人信息',
        describe: describe,
        imgUrl: 'https://assetsprod.onitsukatiger.com/assets/wechat/usergw/user-personalInfo.png'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 600px;
  max-width: 100%;
}

// ::v-deep .el-form-item__label { text-align: left; }
::v-deep .el-form-item__content {
  margin-left: 0;
  width: 70%;
}

::v-deep .el-date-editor.el-input,
.el-select {
  width: 100%;
}

.secondary {
  width: 100%;
}

.primary {
  width: 100%;
  text-align: left;

  h1 {
    font-weight: bold;
    font-size: 2rem;
    margin: 1rem 0;
  }

  .subheader {
    line-height: 1.375rem;
    font-size: 0.875rem;
    margin-bottom: 20px;
  }

  .form-row {
    margin: 1rem 0 2rem;
    display: flex;
    justify-content: space-between;

    .row-left {
      display: flex;
      width: 85%;

      .label {
        width: 25%;
        position: relative;
      }

      .birthday-hits {
        color: #993347;
        font-size: 12px;
        line-height: 17px;
      }

      .birthday-text+.birthday-hits {
        margin-left: 10px;
      }
    }

    .edit {
      margin: 8px 0 0;
      font-size: 1rem;
      letter-spacing: 0.05rem;
      color: #666;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .form-row-line {
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #D8D8D8;
  }
}

@media only screen and (min-width: 768px) {
  .content {
    display: flex;
    flex-direction: row-reverse;

    .secondary {
      width: 295px;
    }

    .primary {
      padding-left: 7%;
    }
  }
}
</style>